(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aa-announcement-rotator')) {
  customElements.define('aa-announcement-rotator', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }

    init() {
      if (!this.isConnected || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.items = Array.from(this.querySelectorAll('.aa-announcement-item'));
      this.items.forEach(item => { item.hidden = true; });
      this.items = this.items.filter(item => item.querySelector('.aa-announcement-text').textContent.trim());
      this.index = 0;
      this.hovered = false;
      this.editorSelected = false;
      this.autoplay = this.dataset.autoplay === 'true';
      this.baseDuration = Math.max(3, Number(this.dataset.speed) || 5) * 1000;
      this.pixelsPerSecond = Math.max(10, Number(this.dataset.scrollSpeed) || 32);
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.manual = this.querySelector('.aa-announcement-manual');
      this.classList.add('aa-ready');
      this.manual.addEventListener('click', () => this.show(this.index + 1), options);
      this.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = true;
        this.syncPause();
      }, options);
      this.addEventListener('pointerleave', () => {
        this.hovered = false;
        this.syncPause();
      }, options);
      this.addEventListener('focusin', () => this.syncPause(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => this.syncPause()), options);
      document.addEventListener('visibilitychange', () => this.syncPause(), options);
      this.motion.addEventListener('change', () => this.show(this.index), options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.items.findIndex(item => item.dataset.blockId === String(event.detail.blockId));
        if (index < 0) return;
        this.editorSelected = true;
        this.show(index);
      }, options);
      this.addEventListener('shopify:block:deselect', () => {
        this.editorSelected = false;
        this.syncPause();
      }, options);
      this.lastWidth = this.getBoundingClientRect().width;
      this.resizeObserver = new ResizeObserver(() => {
        const width = this.getBoundingClientRect().width;
        if (Math.abs(width - this.lastWidth) < 1) return;
        this.lastWidth = width;
        this.show(this.index);
      });
      this.resizeObserver.observe(this);
      this.show(0);
      const controller = this.controller;
      if (document.fonts) document.fonts.ready.then(() => {
        if (this.isConnected && this.controller === controller) this.show(this.index);
      });
    }

    show(index) {
      if (this.animation) {
        this.animation.onfinish = null;
        this.animation.cancel();
        this.animation = null;
      }
      if (!this.items || !this.items.length) return;
      this.index = (index + this.items.length) % this.items.length;
      this.items.forEach((item, i) => { item.hidden = i !== this.index; });
      this.classList.toggle('aa-reduced-motion', this.motion.matches);
      // Reduced-motion users can read long text by horizontal scrolling and switch manually.
      this.manual.hidden = !this.motion.matches || this.items.length < 2;
      const item = this.items[this.index];
      const viewport = item.querySelector('.aa-announcement-viewport');
      const text = item.querySelector('.aa-announcement-text');
      viewport.scrollLeft = 0;
      const distance = Math.max(0, Math.ceil(text.getBoundingClientRect().width - viewport.clientWidth));
      viewport.classList.toggle('aa-overflow', distance > 1);
      if (this.motion.matches || viewport.clientWidth < 1) return;
      const rotate = this.autoplay && this.items.length > 1;
      if (distance <= 1 && !rotate) return;
      const startHold = 1500;
      const travel = distance > 1 ? distance / this.pixelsPerSecond * 1000 : 0;
      const duration = Math.max(this.baseDuration, startHold + travel + 1500);
      const endTransform = `translateX(-${distance}px)`;
      const frames = distance > 1 ? [
        { transform: 'translateX(0)', offset: 0 },
        { transform: 'translateX(0)', offset: startHold / duration },
        { transform: endTransform, offset: (startHold + travel) / duration },
        { transform: endTransform, offset: 1 }
      ] : [{ transform: 'translateX(0)' }, { transform: 'translateX(0)' }];
      this.animation = text.animate(frames, { duration, easing: 'linear', fill: 'forwards' });
      this.animation.onfinish = () => {
        if (rotate) this.show(this.index + 1);
        else this.show(this.index);
      };
      this.syncPause();
    }

    syncPause() {
      if (!this.animation) return;
      const paused = this.hovered || this.contains(document.activeElement) || document.hidden || this.editorSelected;
      if (paused) this.animation.pause();
      else this.animation.play();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      if (this.animation) {
        this.animation.onfinish = null;
        this.animation.cancel();
      }
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
